export const environment = {
  production: true,
  buildId: '2999727192619911',
  configFile: 'config.json',
};
